/* eslint-disable prefer-const */
import React from 'react';
import parse from 'html-react-parser';
import Image from '@ecs/tng-common/components/image/Image';
import { Accordion } from 'react-bootstrap';
import { sharedAssetsPath } from '@ecs/tng-common/scripts/data';
import { IEducationalAccordion } from '../../helpers/interfaces';

interface EducationalAccordionProps {
  data: IEducationalAccordion;
}
export default class EducationalAccordion extends React.Component<EducationalAccordionProps> {
  render() {
    const { data } = this.props;
    return (
      <Accordion
        id={data.id}
        alwaysOpen
        flush
        className="accordion-angle-icon rounded border px-3 px-lg-4 mb-4">
        <Accordion.Item eventKey="0">
          <Accordion.Button
            className="d-flex align-items-center"
            aria-controls="0accordb"
            id="0accordh">
            <span className="bg-teal d-flex flex-grow-0 flex-shrink-0 rounded-circle me-3">
              <Image
                src={`${sharedAssetsPath}/icons/icon-educational-owl.svg`}
                alt="An owl icon"
                width="40"
                height="40"
                className="spot-icon-sm"
                lazyLoading
              />
            </span>
            <span>
              <span className="accordion-header h5 d-block text-secondary">
                {parse(data.title)}
              </span>
              {data.lead ? <span className="body-text-sm">{parse(data.lead)}</span> : null}
            </span>
          </Accordion.Button>
          <Accordion.Body
            id="0accordb"
            aria-labelledby="0accordh"
            role="region">
            {data.content}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
}
